"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGoogleAnalyticsInterface = void 0;
const gtag_1 = require("./helpers/gtag");
const createGoogleAnalyticsInterface = (config) => {
    (0, gtag_1.installGtag)(config.trackingId);
    const analyticsServiceName = "googleAnalytics";
    const configuration = {
        applicationName: config.applicationName,
    };
    const tags = {};
    const event = (name, params = {}) => {
        (0, gtag_1.gtag)("event", name, Object.assign(Object.assign(Object.assign({}, configuration), tags), params));
    };
    const set = (key, value) => {
        tags[key] = value;
    };
    const unset = (key) => {
        if (tags[key])
            delete tags[key];
    };
    const get = (key) => {
        return tags[key];
    };
    return {
        analyticsServiceName,
        event,
        set,
        unset,
        get,
    };
};
exports.createGoogleAnalyticsInterface = createGoogleAnalyticsInterface;
